import * as ReactNamespace from "react";
import { createPortal } from "react-dom";
import { createRoot } from "react-dom/client";

export const React = ReactNamespace;
export const ReactDOM = { createRoot, createPortal };
